import {Box, Grid, IconButton, Stack, Typography} from '@mui/material';
import {useObservable} from '@ngneat/react-rxjs';
import {useSnackbar} from 'notistack';
import React, {useEffect} from 'react';
import {Outlet, useNavigate} from 'react-router-dom';

import {serviceKindsQuery, serviceKindsService} from '@store/settings/serviceKinds';

import {GroupAction} from '@icons/index';

import InfosCard from '@components/cards/infos/Infos.card';

import {Colors} from '@constants/colors.constants';
import {useTranslation} from 'react-i18next';

const ServiceTypesTab = () => {
  const {enqueueSnackbar} = useSnackbar();
  const navigate = useNavigate();
  const {t} = useTranslation();

  const [{serviceKinds}] = useObservable(serviceKindsQuery.serviceKinds$);

  useEffect(() => {
    serviceKindsService.getServiceKinds().subscribe({
      error: (err) => enqueueSnackbar(err.text, err.options),
    });
  }, [enqueueSnackbar]);

  return (
    <>
      <Stack flex={1} spacing={1} p="25px" overflow="hidden">
        <Typography fontSize="30px" fontWeight="700">
          {t('routes.serviceTypes')}
        </Typography>
        <Box flex={1} pt="25px" overflow="hidden">
          <Stack height="100%" overflow="hidden" borderRadius="4px" bgcolor={Colors.white}>
            <Stack p="25px" overflow="auto" className="scrollable">
              <Grid container spacing={2} columns={6}>
                {serviceKinds?.map((serviceKind) => (
                  <Grid item key={serviceKind.id} xs={2}>
                    <InfosCard
                      title={serviceKind.kind}
                      menuOptions={(
                        <>
                          <IconButton
                            sx={{mr: '-7px'}}
                            onClick={(evt) => {
                              evt.stopPropagation();
                              navigate(`${serviceKind.id}`);
                            }}>
                            <GroupAction style={{height: 14, width: 14}}/>
                          </IconButton>
                        </>
                      )}
                      value={serviceKind.code}
                      unit={serviceKind.pctVat + '%'}/>
                  </Grid>
                ))}
              </Grid>
            </Stack>
          </Stack>
        </Box>
      </Stack>
      <Outlet/>
    </>
  );
};

export default ServiceTypesTab;
